import { Button, CircularProgress, Grid2, InputAdornment, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import api from "../../../utils/axios";
import { enqueueSnackbar } from "notistack";
import { IService } from "sierra";
import LangDropdown from "../../../components/LangDropdown";
import { useApp } from "../../../contexts/AppContext";

export default function Register() {
    const location = useLocation()
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { translate, lang } = useApp()

    const isCustomer = !searchParams.get('inviteToken')
    const isManager = searchParams.get('role') === 'manager'
    const isEmployee = searchParams.get('role') === 'employee'
    const service: IService = useMemo(() => location.state?.service, [location])

    const [name, setName] = useState('');
    const [email, setEmail] = useState(!isCustomer ? searchParams.get('email') : '');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPass, setShowPass] = useState(false)
    const [submitting, setSubmitting] = useState(false)


    const handleRegister = () => {
        if (password !== confirmPassword) return enqueueSnackbar('Passwords mismatch', { variant: 'error' })
        setSubmitting(true)
        if (isCustomer) {
            api.post('/customers', { name, email, password }, { meta: { showSnackbar: true } }).then(() => navigate('/login', !service ? undefined : { state: { service: service } })).catch(console.error).finally(() => setSubmitting(false))
        } else if (isManager) {
            api.post('/managers', { invite_token: searchParams.get('inviteToken'), name, password }, { meta: { showSnackbar: true } }).then(() => navigate('/login')).catch(console.error).finally(() => setSubmitting(false))
        } else if (isEmployee) {
            api.post('/employees', { invite_token: searchParams.get('inviteToken'), name, password }, { meta: { showSnackbar: true } }).then(() => navigate('/login')).catch(console.error).finally(() => setSubmitting(false))
        }
    }

    useEffect(() => console.log(service), [])

    return (
        <Grid2 container height={'100vh'} flexDirection={{ xs: 'column', md: 'row' }} gap={2}>
            <Grid2 container size={'grow'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} paddingY={3}>
                <Grid2 container flexDirection={'column'} gap={7} minWidth={{ lg: 500, xs: 'auto' }}>
                    <Grid2>
                        <LangDropdown />
                    </Grid2>
                    <Grid2>
                        <Typography variant="h3" fontWeight={'bold'}>{translate("Register Account")}</Typography>
                    </Grid2>
                    <Grid2 container flexDirection={'column'} gap={3}>
                        <Grid2>
                            <TextField required label={translate('Full Name')} size="small" fullWidth onChange={(e) => setName(e.target.value)} value={name} />
                        </Grid2>
                        <Grid2>
                            <TextField disabled={!isCustomer} required label={translate('Email')} size="small" fullWidth onChange={(e) => setEmail(e.target.value)} value={email} />
                        </Grid2>
                        <Grid2>
                            <TextField required autoComplete="new-password" label={translate('Password')} size='small' type={showPass ? "text" : "password"} fullWidth onChange={(e) => setPassword(e.target.value)} value={password}
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position={lang === 'ar' ? "end" : "start"} onClick={() => setShowPass(v => !v)} sx={{ cursor: 'pointer' }}>
                                                {showPass ? <VisibilityOff /> : <Visibility />}
                                            </InputAdornment>
                                        ),
                                    },
                                }} />
                        </Grid2>
                        <Grid2>
                            <TextField required label={translate('Confirm Password')} size='small' type={showPass ? "text" : "password"} fullWidth onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword}
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position={lang === 'ar' ? "end" : "start"} onClick={() => setShowPass(v => !v)} sx={{ cursor: 'pointer' }}>
                                                {showPass ? <VisibilityOff /> : <Visibility />}
                                            </InputAdornment>
                                        ),
                                    },
                                }} />
                        </Grid2>
                    </Grid2>
                    <Grid2>
                        <Button onClick={handleRegister} disabled={submitting} startIcon={submitting && <CircularProgress />} variant="contained" fullWidth>{translate("REGISTER")}</Button>
                    </Grid2>
                    <Grid2 container display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Grid2>
                            <Typography>{translate("Already have an account?")}</Typography>
                        </Grid2>
                        <Grid2>
                            <Button onClick={() => navigate('/login', !service ? undefined : { state: { service: service } })}>{translate("Login")}</Button>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
            <Grid2 size={'grow'} sx={{ backgroundColor: (t) => t.palette.primary.main }} display={{ xs: 'none', md: 'flex' }} justifyContent={'center'} alignItems={'center'}>
                <img src="/sierra-logo.png" />
            </Grid2>
        </Grid2>
    )
}